import AdminDashboardBreadCrumb from "components/header/AdminDashboardBreadCrumb";
import React from "react";

function AdminBusinessSettingsTermsCondition() {
  return (
    <main
      id="content"
      role="main"
      className="main pointer-event"
      style={{ backgroundColor: "#ffffff" }}
    >
      <div className="content container-fluid">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <AdminDashboardBreadCrumb />
            </li>
            <li className="breadcrumb-item" aria-current="page">
              Terms and conditions
            </li>
          </ol>
        </nav>
        <div className="row" style={{ marginTop: "20px" }}>
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <div className="row justify-content-between pl-4 pr-4">
                  <div>
                    <h2>Terms and conditions</h2>
                  </div>
                </div>
              </div>
              <form>
                <input
                  type="hidden"
                  name="_token"
                  defaultValue="u6GOrXsoRaqVCSqDXnArevLM6wUEqejL2jE0AoWi"
                />{" "}
                <div className="card-body">
                  <div className="form-group">
                    <div className="col-md-12">
                      <label htmlFor="editor">Terms and conditions</label>
                      <textarea
                        className="form-control"
                        id="editor"
                        name="value"
                        style={{ visibility: "hidden", display: "none" }}
                        defaultValue={
                          "<h1>A. Introduction:</h1>\n\n<p>Welcome to  Zambet additionally thusly known as &quot;we&quot;, &quot;us&quot; or &quot; Zambet&quot;. We are an online commercial center and these are the terms and conditions overseeing your entrance and utilization of  Zambet alongside its related sub-areas, destinations, portable application, administrations and apparatuses (the &quot;Website&quot;). By utilizing the Site, you thusly acknowledge these terms and conditions (counting the connected data in this) and speak to that you consent to conform to these terms and conditions (the &quot;Client Agreement&quot;). This User Agreement is regarded as successful upon your utilization of the Site which means your acknowledgment of these terms. On the off chance that you don&#39;t consent to be bound by this User Agreement kindly don&#39;t get to, register with or utilize this Site. This Site is claimed and worked by  Zambet  India Limited, an organization consolidated under the Companies Act, 1994.</p>\n\n<p>The Site maintains whatever authority is needed to change, adjust, include, or expel bits of these Terms and Conditions whenever with no earlier warning. Changes will be successful when posted on the Site with no other notification gave. If it&#39;s not too much trouble check these Terms and Conditions normally for refreshes. You proceed with the utilization of the Site following the presenting of changes on Terms and Conditions of utilization establishes your acknowledgment of those changes.</p>\n\n<p>B. CONDITIONS OF USE</p>\n\n<p>1. YOUR ACCOUNT</p>\n\n<p>To get to specific administrations offered by the stage, we may necessitate that you make a record with us or give individual data to finish the making of a record. We may whenever in our sole and total watchfulness, nullify the username as well as password without giving any explanation or earlier notice and will not be at risk or answerable for any misfortunes endured by, brought about by, emerging out of, regarding or by reason of such solicitation or negation.</p>\n\n<p>Any agreement between us, regardless of whether for utilization of the site or in connection to the buy of items or administrations through the site will be represented by the laws of  India and all gatherings submit to the non-restrictive purview of the  India Courts.</p>\n\n<p>You are answerable for keeping up the classification of your client recognizable proof, password, account subtleties, and related private data. You consent to acknowledge this obligation and guarantee your record and its related subtleties are kept up safely consistently and every essential advance is taken to avoid abuse of your record. You ought to advise us promptly on the off chance that you have any motivation to accept that your secret phrase has gotten known to any other individual, or if the secret word is being, or is probably going to be, utilized in an unapproved way. You concur and recognize that any utilization of the Site and related administrations offered as well as any entrance to private data, information or interchanges utilizing your record and secret word will be esteemed to be either performed by you or approved by you all things considered. You consent to be bound by any entrance of the Site as well as utilization of any administrations offered by the Site (regardless of whether such access or use are approved by you or not). You concur that we will be entitled (yet not obliged) to follow up on, depend on or consider you exclusively capable and subject in regard thereof as though the equivalent were done or transmitted by you. You further concur and recognize that you will be bound by and consent to completely reimburse us against all misfortunes emerging from the utilization of or access to the Site through your record.</p>\n\n<p>It would be ideal if you guarantee that the subtleties you give us are right and finish consistently. You are committed to refreshing insights regarding your record progressively by getting to your record on the web. For snippets of data you are not ready to refresh by getting to Your Account on the Site, you should advise us by means of our client care correspondence channels to help you with these changes. We claim all authority to decline access to the Site, end records, evacuate or alter content whenever without earlier notice to you. We may whenever in our sole and total carefulness, demand that you update your Personal Data or forthwith negate the record or related subtleties without giving any explanation or earlier notice and will not be at risk or liability for any misfortunes endured by or brought about by you or emerging out of or regarding or by reason of such solicitation or nullification. You thusly consent to change your secret key now and again and to keep your record secure and furthermore will be answerable for the privacy of your record and obligated for any revelation or use (regardless of whether such use is approved or not) of the username and additionally secret key.</p>\n\n<p>2. Your account vs your order</p>\n\n<p>We Only Consider the name of an  Zambet account holder as the owner of and the client of the product(s) which has been ordered from the respective  Zambet account. You should not request for any changes in the name of the owner while delivering the product (i.e.: Motor Bike/Car, apartments, lands etc.)</p>\n\n<p> Zambet&nbsp;retains all kinds of authority to ban/cancel/freeze/unfreeze your account(s) if they think it should be done so.  Zambet is not bound to provide the balance amount (of cashback)to you if your account is blocked/banned. Any kind of balance paid by you through bkash/bank/cash would be refunded to you within a reasonable time period. Please note that it may depend on the calculation of your total payment vs the cashback you received and used.</p>\n\n<p>3. Your Conduct:</p>\n\n<p>You should not utilize the site at all that causes, or is probably going to cause, the Site or access to it to interfere, harmed or disabled in any capacity. You should not participate in exercises that could hurt or conceivably hurt the Site, its workers, officials, delegates, partners or some other gathering legitimately or in a roundabout way connected with the Site or access to it to be intruded, harmed or debilitated in any capacity. You comprehend that you, and not us, are answerable for every single electronic correspondence and substance sent from your PC to us and you should utilize the Site for legal purposes as it were. You are carefully restricted from utilizing the Site</p>\n\n<p> Zambet&nbsp;might not be subject to any individual for any misfortune or harm, which may emerge from the utilization of any of the data contained in any of the materials on this site.</p>\n\n<ul>\n\t<li>for deceitful purposes, or regarding a criminal offense or other unlawful movements</li>\n\t<li>to send, utilize or reuse any material that doesn&#39;t have a place with you; or is illicit, hostile (counting yet not constrained to material that is explicitly unequivocal substance or which advances prejudice, dogmatism, scorn or physical mischief), tricky, misdirecting, damaging, foul, hassling, disrespectful, abusive, derogatory, vulgar, obscene, pedophilic or threatening; ethically questionable, stigmatizing or in break of copyright, trademark, secrecy, protection or some other exclusive data or right; or is generally damaging to outsiders; or identifies with or advances tax evasion or betting; or is unsafe to minors in any capacity; or mimics someone else; or undermines the solidarity, trustworthiness, security or power of  India or neighborly relations with remote States; or offensive or generally unlawful in any way at all; or which comprises of or contains programming infections, political battling, business sales, networking letters, mass mailings or any &lsquo;spam&lsquo;</li>\n\t<li>Use the Site for illicit purposes.</li>\n\t<li>to cause irritation, bother or unnecessary nervousness</li>\n\t<li>for whatever other purposes that is other than what is expected by us</li>\n</ul>\n\n<p>4. Submission:</p>\n\n<p>Anything that you submit to the Site or potentially give to us, including yet not restricted to, questions, audits, remarks, and proposals (on the whole, &quot;Entries&quot;) will turn into our sole and selective property and will not become back to you. Notwithstanding the rights pertinent to any Submission, when you present remarks or surveys on the Site, you additionally award us the privilege to utilize the name that you submit, regarding such audit, remark, or other substance. You will not utilize a bogus email address, profess to be somebody other than yourself or generally misdirect us or outsiders with regards to the cause of any Submissions. We may, yet will not be committed to, expel or alter any Submissions with no notification or lawful course appropriate to us in such manner.</p>\n\n<p>5. CLAIMS AGAINST OBJECTIONABLE CONTENT:</p>\n\n<p>We list a huge number of items including apartments &amp; Lands available to be purchased offered by various dealers on the Site and host different remarks on postings, it isn&#39;t workable for us to know about the substance of every item recorded available to be purchased or each remark or survey that is shown. Appropriately, we work on a &quot;guarantee, audit and takedown&quot; premise. On the off chance that you accept that any substance on the Site is illicit, hostile (counting yet not restricted to material that is explicitly express substance or which advances prejudice, bias, scorn or physical mischief), beguiling, deluding, harsh, profane, irritating, impious, slanderous, offensive, revolting, obscene, pedophilic or threatening; ethnically questionable, criticizing; or is generally damaging to outsiders; or identifies with or advances tax evasion or betting; or isdestructive to minors in any capacity; or mimics someone else; or compromises the solidarity, trustworthiness, security or sway of  India or cordial relations with remoteStates; or shocking or generally unlawful in any way at all; or which comprises of or contains programming infections, (&quot; frightful substance &quot;), please tell us quickly by following by keeping in touch with us on legal@ Zambet.com. We will make every single useful undertaking to examine and evacuate substantial offensive substance griped about inside a sensible measure of time.</p>\n\n<p>If it&#39;s not too much trouble guarantee to give your name, address, contact data and the same number of pertinent subtleties of the case including the name of frightful substance party, occasions of protest, confirmation of complaint among others. If you don&#39;t mind note that giving inadequate subtleties will ruin your case and unusable for legitimate purposes.</p>\n\n<p>6. CLAIMS AGAINST INFRINGING CONTENT:</p>\n\n<p>We regard the licensed innovation of others. On the off chance that you accept that your licensed innovation rights have been utilized such that offers to ascend to worries of encroachment if it&#39;s not too much trouble illuminate us and we will endeavor every single sensible exertion to address your worry inside a sensible measure of time. It would be ideal if you guarantee to give your name, address, contact data and the same number of pertinent subtleties of the case including the name of encroaching gathering, cases of encroachment, and verification of encroachment among others. If you don&#39;t mind note that giving deficient subtleties will ruin your case and unusable for lawful purposes. What&#39;s more, giving bogus or misdirecting data might be viewed as a legitimate offense and might be trailed by lawful procedures.</p>\n\n<p>We likewise regard a maker&#39;s entitlement to go into selective appropriation or resale understandings for its items. In any case, infringement of such understandings doesn&rsquo;t establish licensed innovation rights encroachment. As the implementation of these understandings is an issue between the producer, wholesaler and additionally particular affiliate, it would not be befitting for us to aid the authorization of such exercises. While we can&#39;t give legitimate guidance, nor share private data as secured by the law, we suggest that any inquiries or concerns with respect to your privileges might be steered to lawful authority.</p>\n\n<p>7. Indemnity</p>\n\n<p>You will repay and hold innocuous  Zambet Limited, its auxiliaries, offshoots, and their particular officials, executives, operators, and representatives, from any case or request, or activities including sensible lawyer&#39;s expenses, made by any outsider or punishment forced due to or emerging out of your break of these Terms and Conditions or any record joined by reference, or your infringement of any law, rules, guidelines or the privileges of an outsider.</p>\n\n<p>You therefore explicitly discharge  Zambet as possessed by offshoots as well as any of its officials and delegates from any cost, harm, obligation or other outcome of any of the activities/inactions of the merchants or other specialist co-ops and explicitly waiver any cases or requests that you may have for this benefit under any resolution, contract or something else.</p>\n\n<p>8. Losses</p>\n\n<p>We won&#39;t be answerable for any business or individual misfortunes (counting however not restricted to loss of benefits, income, contracts, foreseen investment funds, information, altruism, or squandered consumption) or whatever other backhanded or weighty misfortune that isn&#39;t sensibly predictable to both you and us when you initiated utilizing the Site.</p>\n\n<p>9. Corrections TO CONDITIONS OR ALTERATIONS OF SERVICE AND RELATED PROMISE</p>\n\n<p>We maintain all authority to make changes to the Site, its strategies, these terms and conditions and some other freely showed condition or administration guarantee whenever. You will be dependent upon the approaches and terms and conditions in power at the time you utilized the Site except if any change to those strategies or these conditions is required to be made by law or government expert (in which case it will apply to orders recently set by you). In the event that any of these conditions is regarded invalid, void, or in any way, shape or form unenforceable, that condition will be considered severable and won&#39;t influence the legitimacy and enforceability of any outstanding condition.</p>\n\n<p>10. WAIVER</p>\n\n<p>You recognize and perceive that we are a private business endeavor and claim all authority to lead the business to accomplish our targets in a way we esteem fit. You additionally recognize that in the event that you break the conditions expressed on our Site and we make no move, we are as yet qualified for utilizing our privileges and cures in whatever other circumstance where you rupture these conditions.</p>\n\n<p>11. Administering LAW AND JURISDICTION</p>\n\n<p>These terms and conditions are administered by and interpreted as per the laws of The People&#39;s Republic of  India. You concur that the courts, councils and additionally semi-legal bodies situated in Dhaka,  India will have the restrictive purview on any question emerging inside  India under this Agreement.</p>\n\n<p>12. Offers:</p>\n\n<p> Zambet&nbsp;is not liable or bound to provide any other offers of any merchant/importer/ vendors&rsquo; at any other places/sites except  Zambet. You can just request/ask/solicitation or look for data about the offers given/declared by  Zambet.</p>\n\n<p>One client will have the option to buy one item during any special offers (*if not allowed and announced multiple quantities by  Zambet).</p>\n\n<p>Customers cannot claim to withdraw any kind of cashback by any other form (example - by bkash, bank or cash) except  Zambet balance.</p>\n\n<p>13. Valuing, AVAILABILITY AND ORDER PROCESSING</p>\n\n<p>All costs are recorded in  India  Rupee ( INR) and are comprehensive of VAT and are recorded on the Site by the merchant that is selling the item or administration. Things in your Shopping Cart will consistently mirror the latest value shown on the thing&#39;s item detail page. If it&#39;s not too much trouble note that this cost may vary from the value appeared for the thing when you previously put it in your truck. Putting a thing in your truck doesn&#39;t save the value that appeared around then. It is additionally conceivable that a thing&#39;s cost may diminish between the time you place it in your bin and the time you buy it.</p>\n\n<p>We don&#39;t offer value coordinating for any things sold by any merchant on our Site or different sites.</p>\n\n<p>We are resolved to give the most exact evaluating data on the Site to our clients; be that as it may, blunders may at present happen, for example, situations when the cost of a thing isn&#39;t shown effectively on the Site. In that capacity, we maintain all authority to won&#39;t or drop any request. If a thing is mispriced, we may, at our own tact, either get in touch with you for guidelines or drop your request and advise you of such crossing out. We will reserve the option to can&#39;t or drop any such requests whether the request has been affirmed and your prepayment handled. On the off chance that such a retraction happens on your prepaid request, our approaches for the discount will apply. If it&#39;s not too much trouble note that  Zambet has 100% right on the discount sum. Generally, the discount sum is determined dependent on the client followed through on cost in the wake of deducting any kind of markdown and delivery charge.</p>\n\n<p>We list accessibility data for items recorded on the Site, remembering for every item data page. Past what we state on that page or generally on the Site, we can&#39;t be increasingly explicit about accessibility. It would be ideal if you note that dispatch gauges are only that. They are not ensured dispatch times and ought not to be depended upon in that capacity. As we process your request, you will be educated by email or SMS if any items you request end up being inaccessible.</p>\n\n<p>It would be ideal if you note that there are situations when a request can&#39;t be prepared for different reasons. The Site maintains whatever authority is needed to won&#39;t or drop any request in any way, shape or form at some random time. You might be approached to give extra confirmation or data, including yet not constrained to telephone numbers and address, before we acknowledge the request.</p>\n\n<p>So as to keep away from any extortion with a credit or check cards, we maintain whatever authority is needed to acquire approval of your installment subtleties before furnishing you with the item and to confirm the individual data you imparted to us. This confirmation can take the state of a character, spot of habitation, or banking data check. The nonappearance of an answer following such a request will naturally cause the wiping out of the request inside a sensible timetable. We maintain whatever authority is needed to continue to coordinate undoing of a request for which we presume a danger of false utilization of banking instruments or different reasons without earlier notice or any ensuing lawful obligation.</p>\n\n<p>If there is any mistakes found regarding pricing (example- overpriced than the MRP or lower price than the MRP) of any product and if the seller delivers that mispriced product even after notified by customer and if any action is not taken by the seller even after notified by customer then the seller will be solely legally liable for this.</p>\n\n<p>14. Special Items</p>\n\n<p>SECURITY AND FRAUD</p>\n\n<ul>\n\t<li>When you utilize a voucher, you warrant to  Zambet that you are the appropriately approved beneficiary of the voucher and that you are utilizing it in compliance with common decency.</li>\n\t<li>If you recover, endeavor to reclaim or support the recovery of voucher to acquire limits to which you are not entitled you might be perpetrating a common or criminal offense</li>\n\t<li>If we sensibly accept that any voucher is being utilized unlawfully or illicitly, we may reject or drop any voucher/request and you concur that you will have no case against us in regard of any dismissal or crossing out.  Zambet maintains whatever authority is needed to make any further move it considers suitable in such occasions</li>\n</ul>\n\n<p>15. Mass Purchasing</p>\n\n<p> Zambet&nbsp;sites are accessible for non-business and residential utilization as it were. We maintain all authority to reject or cross out your request on the off chance that we trust you are requesting our items for business or other re-deal purposes. We apply breaking points to some of our items to ensure stock accessibility so that whatever number of our clients as could be expected under the circumstances can purchase our items.</p>\n\n<p>16. RESELLING  Zambet PRODUCTS</p>\n\n<p>Reselling  Zambet products for business purposes is strictly prohibited.If any unauthorized personnel are found committing the above act,legal action may be taken against him/her. If it is found and proventhat any order has been placed to cash out the paid amount, legalaction may be taken against him/her. If any seller orders (as acustomer) from their own shop using cashback or any other balanceit would be considered as the violation of the act mentioned above.In that case seller (as seller account) &amp; customer (as customeraccount) would be bound to oblige the decision taken by  Zambet aswell as legal action may be taken.</p>\n\n<p>17. Stock availability</p>\n\n<p>The orders are subject to availability of stock. If there is any problem with stock then the order can be canceled at any time, irrespective of any duration.</p>\n\n<p>18. Delivery Timeline</p>\n\n<p>The delivery might take longer than usual timeframe/line to be followed by  Zambet. The delivery timeframe is only subject to estimation and please consider and calculate the announced timeframe as working days. It might vary depending upon the circumstances. Delivery might be delayed due to force majeure events which include, but not limited to, political unrest, political event, national/public holidays/official holiday(s), etc.</p>\n\n<p>19. Delivery Charge(s)</p>\n\n<p> Zambet&nbsp;will bear delivery charges for the order(s) with the following conditions unless otherwise there is any specific campaign wise instruction for delivery charge.</p>\n\n<p>19.1. Weight must be no more than 10 Kgs.</p>\n\n<p>19.2. Size Must be within 1 cubic foot.</p>\n\n<p>Please note that,</p>\n\n<p>i) Fragile and/or Sensitive items (example Electronics, Home appliances, decorative items, crockeries etc.) may be excluded from the above conditions.</p>\n\n<p>ii) Delivery charge(s) may applicable if seller deliver the product(s).</p>\n\n<p>iii) Waiver of the delivery charge(s) may depend on different circumstances such as delivery area, road conditions, transportations cost etc.</p>\n\n<p>iv) liquid items, gymnasium instruments and any kind of product that may require special carrying facilities are excluded from the above condition.</p>\n\n<p>v) If collection or delivery of a Consignment takes place at your premises, we shall not be under any obligation to provide any equipment or labor or any associated cost(s) which, apart from the driver collecting the Consignment, may be required for loading or unloading of a Consignment. Delivery charge does not include any installation cost. Installation cost (if there is any) is subject to supplier&rsquo;s policy.</p>\n\n<p>vi) Provision of the home delivery is/are subject to carrier and sellers&rsquo; delivery policy.</p>\n\n<p>vii) If any delivery fails due to customer negligence or any other reason from the customer end then the customer is bound to pay the return courier charge(s) as well as the redelivery charge(s).</p>\n\n<p>20. Returns Policy</p>\n\n<p>1.If your item is faulty/harmed or mistaken/deficient at the hour of conveyance, if you don&#39;t mind, please get in touch with us inside the pertinent return window. Your item might be qualified for discount or substitution relying upon the item class and condition.</p>\n\n<p>2. Please note that a few items are not qualified for arrival if the item is &quot;Never again required&quot;</p>\n\n<p>3. For gadget related issues after use or the lapse of the arrival window, we will allude you to the brand guarantee focus (if relevant).</p>\n\n<p>4. Please note that you should keep and be able to provide proper documentations and proof about your return/refund claim (i.e. unboxing video, receiving invoice, etc.).</p>\n\n<p>21. Cancellation</p>\n\n<p> Zambet&nbsp;retains unqualified right to cancel any order at its sole discretion prior to dispatch and for any reason which may include, but not limited to, the product being mispriced, out of stock, expired, defective, malfunctioned, and containing incorrect information or description arising out of technical or typographical error or for any other reason.</p>\n\n<p>22. Refund</p>\n\n<p>In case of any cancellations of any order(s) due to inevitablecircumstances the paid amount would be refunded as thecustomers&rsquo;  Zambet account firstly. Customer need to report an issueas refund category and should mention his/her desired refund type(i.e. bkash/bank) along with details (bkash personal number, bankaccount details)</p>"
                        }
                      />
                      <div
                        id="cke_editor"
                        className="cke_1 cke cke_reset cke_chrome cke_editor_editor cke_ltr cke_browser_webkit"
                        dir="ltr"
                        lang="en"
                        role="application"
                        aria-labelledby="cke_editor_arialbl"
                      >
                        <span
                          id="cke_editor_arialbl"
                          className="cke_voice_label"
                        >
                          Rich Text Editor, editor
                        </span>
                        <div
                          className="cke_inner cke_reset"
                          role="presentation"
                        >
                          <span
                            id="cke_1_top"
                            className="cke_top cke_reset_all"
                            role="presentation"
                            style={{ height: "auto", userSelect: "none" }}
                          >
                            <span id="cke_9" className="cke_voice_label">
                              Editor toolbars
                            </span>
                            <span
                              id="cke_1_toolbox"
                              className="cke_toolbox"
                              role="group"
                              aria-labelledby="cke_9"
                              onmousedown="return false;"
                            >
                              <span
                                id="cke_12"
                                className="cke_toolbar"
                                aria-labelledby="cke_12_label"
                                role="toolbar"
                              >
                                <span
                                  id="cke_12_label"
                                  className="cke_voice_label"
                                >
                                  Clipboard/Undo
                                </span>
                                <span className="cke_toolbar_start" />
                                <span
                                  className="cke_toolgroup"
                                  role="presentation"
                                >
                                  <a
                                    id="cke_13"
                                    className="cke_button cke_button__cut cke_button_disabled "
                                    href="javascript:void('Cut')"
                                    title="Cut (Ctrl+X)"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_13_label"
                                    aria-describedby="cke_13_description"
                                    aria-haspopup="false"
                                    aria-disabled="true"
                                    onkeydown="return CKEDITOR.tools.callFunction(2,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(3,event);"
                                    onclick="CKEDITOR.tools.callFunction(4,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__cut_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -312px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_13_label"
                                      className="cke_button_label cke_button__cut_label"
                                      aria-hidden="false"
                                    >
                                      Cut
                                    </span>
                                    <span
                                      id="cke_13_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    >
                                      &nbsp;Keyboard shortcut Ctrl+X
                                    </span>
                                  </a>
                                  <a
                                    id="cke_14"
                                    className="cke_button cke_button__copy cke_button_disabled "
                                    href="javascript:void('Copy')"
                                    title="Copy (Ctrl+C)"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_14_label"
                                    aria-describedby="cke_14_description"
                                    aria-haspopup="false"
                                    aria-disabled="true"
                                    onkeydown="return CKEDITOR.tools.callFunction(5,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(6,event);"
                                    onclick="CKEDITOR.tools.callFunction(7,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__copy_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -264px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_14_label"
                                      className="cke_button_label cke_button__copy_label"
                                      aria-hidden="false"
                                    >
                                      Copy
                                    </span>
                                    <span
                                      id="cke_14_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    >
                                      &nbsp;Keyboard shortcut Ctrl+C
                                    </span>
                                  </a>
                                  <a
                                    id="cke_15"
                                    className="cke_button cke_button__paste cke_button_off"
                                    href="javascript:void('Paste')"
                                    title="Paste (Ctrl+V)"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_15_label"
                                    aria-describedby="cke_15_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(8,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(9,event);"
                                    onclick="CKEDITOR.tools.callFunction(10,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__paste_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -360px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_15_label"
                                      className="cke_button_label cke_button__paste_label"
                                      aria-hidden="false"
                                    >
                                      Paste
                                    </span>
                                    <span
                                      id="cke_15_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    >
                                      &nbsp;Keyboard shortcut Ctrl+V
                                    </span>
                                  </a>
                                  <a
                                    id="cke_16"
                                    className="cke_button cke_button__pastetext cke_button_off"
                                    href="javascript:void('Paste as plain text')"
                                    title="Paste as plain text (Ctrl+Shift+V)"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_16_label"
                                    aria-describedby="cke_16_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(11,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(12,event);"
                                    onclick="CKEDITOR.tools.callFunction(13,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__pastetext_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -1872px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_16_label"
                                      className="cke_button_label cke_button__pastetext_label"
                                      aria-hidden="false"
                                    >
                                      Paste as plain text
                                    </span>
                                    <span
                                      id="cke_16_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    >
                                      &nbsp;Keyboard shortcut Ctrl+Shift+V
                                    </span>
                                  </a>
                                  <a
                                    id="cke_17"
                                    className="cke_button cke_button__pastefromword cke_button_off"
                                    href="javascript:void('Paste from Word')"
                                    title="Paste from Word"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_17_label"
                                    aria-describedby="cke_17_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(14,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(15,event);"
                                    onclick="CKEDITOR.tools.callFunction(16,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__pastefromword_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -1824px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_17_label"
                                      className="cke_button_label cke_button__pastefromword_label"
                                      aria-hidden="false"
                                    >
                                      Paste from Word
                                    </span>
                                    <span
                                      id="cke_17_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    />
                                  </a>
                                  <span
                                    className="cke_toolbar_separator"
                                    role="separator"
                                  />
                                  <a
                                    id="cke_18"
                                    className="cke_button cke_button__undo cke_button_disabled "
                                    href="javascript:void('Undo')"
                                    title="Undo (Ctrl+Z)"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_18_label"
                                    aria-describedby="cke_18_description"
                                    aria-haspopup="false"
                                    aria-disabled="true"
                                    onkeydown="return CKEDITOR.tools.callFunction(17,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(18,event);"
                                    onclick="CKEDITOR.tools.callFunction(19,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__undo_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -2448px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_18_label"
                                      className="cke_button_label cke_button__undo_label"
                                      aria-hidden="false"
                                    >
                                      Undo
                                    </span>
                                    <span
                                      id="cke_18_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    >
                                      &nbsp;Keyboard shortcut Ctrl+Z
                                    </span>
                                  </a>
                                  <a
                                    id="cke_19"
                                    className="cke_button cke_button__redo cke_button_disabled "
                                    href="javascript:void('Redo')"
                                    title="Redo (Ctrl+Y)"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_19_label"
                                    aria-describedby="cke_19_description"
                                    aria-haspopup="false"
                                    aria-disabled="true"
                                    onkeydown="return CKEDITOR.tools.callFunction(20,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(21,event);"
                                    onclick="CKEDITOR.tools.callFunction(22,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__redo_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -2400px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_19_label"
                                      className="cke_button_label cke_button__redo_label"
                                      aria-hidden="false"
                                    >
                                      Redo
                                    </span>
                                    <span
                                      id="cke_19_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    >
                                      &nbsp;Keyboard shortcut Ctrl+Y
                                    </span>
                                  </a>
                                </span>
                                <span className="cke_toolbar_end" />
                              </span>
                              <span
                                id="cke_20"
                                className="cke_toolbar"
                                aria-labelledby="cke_20_label"
                                role="toolbar"
                              >
                                <span
                                  id="cke_20_label"
                                  className="cke_voice_label"
                                >
                                  Editing
                                </span>
                                <span className="cke_toolbar_start" />
                                <span
                                  className="cke_toolgroup"
                                  role="presentation"
                                >
                                  <a
                                    id="cke_21"
                                    className="cke_button cke_button__scayt cke_button_off cke_button_expandable"
                                    href="javascript:void('Spell Check As You Type')"
                                    title="Spell Check As You Type"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_21_label"
                                    aria-describedby="cke_21_description"
                                    aria-haspopup="menu"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(23,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(24,event);"
                                    onclick="CKEDITOR.tools.callFunction(25,this);return false;"
                                    aria-expanded="false"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__scayt_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -2040px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_21_label"
                                      className="cke_button_label cke_button__scayt_label"
                                      aria-hidden="false"
                                    >
                                      Spell Check As You Type
                                    </span>
                                    <span
                                      id="cke_21_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    />
                                    <span className="cke_button_arrow" />
                                  </a>
                                </span>
                                <span className="cke_toolbar_end" />
                              </span>
                              <span
                                id="cke_22"
                                className="cke_toolbar"
                                aria-labelledby="cke_22_label"
                                role="toolbar"
                              >
                                <span
                                  id="cke_22_label"
                                  className="cke_voice_label"
                                >
                                  Links
                                </span>
                                <span className="cke_toolbar_start" />
                                <span
                                  className="cke_toolgroup"
                                  role="presentation"
                                >
                                  <a
                                    id="cke_23"
                                    className="cke_button cke_button__link cke_button_off"
                                    href="javascript:void('Link')"
                                    title="Link (Ctrl+K)"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_23_label"
                                    aria-describedby="cke_23_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(26,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(27,event);"
                                    onclick="CKEDITOR.tools.callFunction(28,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__link_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -1512px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_23_label"
                                      className="cke_button_label cke_button__link_label"
                                      aria-hidden="false"
                                    >
                                      Link
                                    </span>
                                    <span
                                      id="cke_23_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    >
                                      &nbsp;Keyboard shortcut Ctrl+K
                                    </span>
                                  </a>
                                  <a
                                    id="cke_24"
                                    className="cke_button cke_button__unlink cke_button_disabled "
                                    href="javascript:void('Unlink')"
                                    title="Unlink"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_24_label"
                                    aria-describedby="cke_24_description"
                                    aria-haspopup="false"
                                    aria-disabled="true"
                                    onkeydown="return CKEDITOR.tools.callFunction(29,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(30,event);"
                                    onclick="CKEDITOR.tools.callFunction(31,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__unlink_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -1536px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_24_label"
                                      className="cke_button_label cke_button__unlink_label"
                                      aria-hidden="false"
                                    >
                                      Unlink
                                    </span>
                                    <span
                                      id="cke_24_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    />
                                  </a>
                                  <a
                                    id="cke_25"
                                    className="cke_button cke_button__anchor cke_button_off"
                                    href="javascript:void('Anchor')"
                                    title="Anchor"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_25_label"
                                    aria-describedby="cke_25_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(32,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(33,event);"
                                    onclick="CKEDITOR.tools.callFunction(34,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__anchor_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -1488px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_25_label"
                                      className="cke_button_label cke_button__anchor_label"
                                      aria-hidden="false"
                                    >
                                      Anchor
                                    </span>
                                    <span
                                      id="cke_25_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    />
                                  </a>
                                </span>
                                <span className="cke_toolbar_end" />
                              </span>
                              <span
                                id="cke_26"
                                className="cke_toolbar"
                                aria-labelledby="cke_26_label"
                                role="toolbar"
                              >
                                <span
                                  id="cke_26_label"
                                  className="cke_voice_label"
                                >
                                  Insert
                                </span>
                                <span className="cke_toolbar_start" />
                                <span
                                  className="cke_toolgroup"
                                  role="presentation"
                                >
                                  <a
                                    id="cke_27"
                                    className="cke_button cke_button__image cke_button_off"
                                    href="javascript:void('Image')"
                                    title="Image"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_27_label"
                                    aria-describedby="cke_27_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(35,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(36,event);"
                                    onclick="CKEDITOR.tools.callFunction(37,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__image_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -1224px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_27_label"
                                      className="cke_button_label cke_button__image_label"
                                      aria-hidden="false"
                                    >
                                      Image
                                    </span>
                                    <span
                                      id="cke_27_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    />
                                  </a>
                                  <a
                                    id="cke_28"
                                    className="cke_button cke_button__table cke_button_off"
                                    href="javascript:void('Table')"
                                    title="Table"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_28_label"
                                    aria-describedby="cke_28_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(38,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(39,event);"
                                    onclick="CKEDITOR.tools.callFunction(40,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__table_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -2280px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_28_label"
                                      className="cke_button_label cke_button__table_label"
                                      aria-hidden="false"
                                    >
                                      Table
                                    </span>
                                    <span
                                      id="cke_28_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    />
                                  </a>
                                  <a
                                    id="cke_29"
                                    className="cke_button cke_button__horizontalrule cke_button_off"
                                    href="javascript:void('Insert Horizontal Line')"
                                    title="Insert Horizontal Line"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_29_label"
                                    aria-describedby="cke_29_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(41,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(42,event);"
                                    onclick="CKEDITOR.tools.callFunction(43,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__horizontalrule_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -1176px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_29_label"
                                      className="cke_button_label cke_button__horizontalrule_label"
                                      aria-hidden="false"
                                    >
                                      Insert Horizontal Line
                                    </span>
                                    <span
                                      id="cke_29_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    />
                                  </a>
                                  <a
                                    id="cke_30"
                                    className="cke_button cke_button__specialchar cke_button_off"
                                    href="javascript:void('Insert Special Character')"
                                    title="Insert Special Character"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_30_label"
                                    aria-describedby="cke_30_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(44,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(45,event);"
                                    onclick="CKEDITOR.tools.callFunction(46,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__specialchar_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -2256px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_30_label"
                                      className="cke_button_label cke_button__specialchar_label"
                                      aria-hidden="false"
                                    >
                                      Insert Special Character
                                    </span>
                                    <span
                                      id="cke_30_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    />
                                  </a>
                                </span>
                                <span className="cke_toolbar_end" />
                              </span>
                              <span
                                id="cke_31"
                                className="cke_toolbar"
                                aria-labelledby="cke_31_label"
                                role="toolbar"
                              >
                                <span
                                  id="cke_31_label"
                                  className="cke_voice_label"
                                >
                                  Tools
                                </span>
                                <span className="cke_toolbar_start" />
                                <span
                                  className="cke_toolgroup"
                                  role="presentation"
                                >
                                  <a
                                    id="cke_32"
                                    className="cke_button cke_button__maximize cke_button_off"
                                    href="javascript:void('Maximize')"
                                    title="Maximize"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_32_label"
                                    aria-describedby="cke_32_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(47,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(48,event);"
                                    onclick="CKEDITOR.tools.callFunction(49,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__maximize_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -1680px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_32_label"
                                      className="cke_button_label cke_button__maximize_label"
                                      aria-hidden="false"
                                    >
                                      Maximize
                                    </span>
                                    <span
                                      id="cke_32_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    />
                                  </a>
                                </span>
                                <span className="cke_toolbar_end" />
                              </span>
                              <span
                                id="cke_33"
                                className="cke_toolbar"
                                aria-labelledby="cke_33_label"
                                role="toolbar"
                              >
                                <span
                                  id="cke_33_label"
                                  className="cke_voice_label"
                                >
                                  Document
                                </span>
                                <span className="cke_toolbar_start" />
                                <span
                                  className="cke_toolgroup"
                                  role="presentation"
                                >
                                  <a
                                    id="cke_34"
                                    className="cke_button cke_button__source cke_button_off"
                                    href="javascript:void('Source')"
                                    title="Source"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_34_label"
                                    aria-describedby="cke_34_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(50,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(51,event);"
                                    onclick="CKEDITOR.tools.callFunction(52,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__source_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -2184px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_34_label"
                                      className="cke_button_label cke_button__source_label"
                                      aria-hidden="false"
                                    >
                                      Source
                                    </span>
                                    <span
                                      id="cke_34_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    />
                                  </a>
                                </span>
                                <span className="cke_toolbar_end" />
                              </span>
                              <span className="cke_toolbar_break" />
                              <span
                                id="cke_35"
                                className="cke_toolbar"
                                aria-labelledby="cke_35_label"
                                role="toolbar"
                              >
                                <span
                                  id="cke_35_label"
                                  className="cke_voice_label"
                                >
                                  Basic Styles
                                </span>
                                <span className="cke_toolbar_start" />
                                <span
                                  className="cke_toolgroup"
                                  role="presentation"
                                >
                                  <a
                                    id="cke_36"
                                    className="cke_button cke_button__bold cke_button_off"
                                    href="javascript:void('Bold')"
                                    title="Bold (Ctrl+B)"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_36_label"
                                    aria-describedby="cke_36_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(53,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(54,event);"
                                    onclick="CKEDITOR.tools.callFunction(55,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__bold_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -24px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_36_label"
                                      className="cke_button_label cke_button__bold_label"
                                      aria-hidden="false"
                                    >
                                      Bold
                                    </span>
                                    <span
                                      id="cke_36_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    >
                                      &nbsp;Keyboard shortcut Ctrl+B
                                    </span>
                                  </a>
                                  <a
                                    id="cke_37"
                                    className="cke_button cke_button__italic cke_button_off"
                                    href="javascript:void('Italic')"
                                    title="Italic (Ctrl+I)"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_37_label"
                                    aria-describedby="cke_37_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(56,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(57,event);"
                                    onclick="CKEDITOR.tools.callFunction(58,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__italic_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -48px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_37_label"
                                      className="cke_button_label cke_button__italic_label"
                                      aria-hidden="false"
                                    >
                                      Italic
                                    </span>
                                    <span
                                      id="cke_37_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    >
                                      &nbsp;Keyboard shortcut Ctrl+I
                                    </span>
                                  </a>
                                  <a
                                    id="cke_38"
                                    className="cke_button cke_button__strike cke_button_off"
                                    href="javascript:void('Strikethrough')"
                                    title="Strikethrough"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_38_label"
                                    aria-describedby="cke_38_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(59,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(60,event);"
                                    onclick="CKEDITOR.tools.callFunction(61,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__strike_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -72px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_38_label"
                                      className="cke_button_label cke_button__strike_label"
                                      aria-hidden="false"
                                    >
                                      Strikethrough
                                    </span>
                                    <span
                                      id="cke_38_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    />
                                  </a>
                                  <span
                                    className="cke_toolbar_separator"
                                    role="separator"
                                  />
                                  <a
                                    id="cke_39"
                                    className="cke_button cke_button__removeformat cke_button_off"
                                    href="javascript:void('Remove Format')"
                                    title="Remove Format"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_39_label"
                                    aria-describedby="cke_39_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(62,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(63,event);"
                                    onclick="CKEDITOR.tools.callFunction(64,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__removeformat_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -1992px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_39_label"
                                      className="cke_button_label cke_button__removeformat_label"
                                      aria-hidden="false"
                                    >
                                      Remove Format
                                    </span>
                                    <span
                                      id="cke_39_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    />
                                  </a>
                                </span>
                                <span className="cke_toolbar_end" />
                              </span>
                              <span
                                id="cke_40"
                                className="cke_toolbar"
                                aria-labelledby="cke_40_label"
                                role="toolbar"
                              >
                                <span
                                  id="cke_40_label"
                                  className="cke_voice_label"
                                >
                                  Paragraph
                                </span>
                                <span className="cke_toolbar_start" />
                                <span
                                  className="cke_toolgroup"
                                  role="presentation"
                                >
                                  <a
                                    id="cke_41"
                                    className="cke_button cke_button__numberedlist cke_button_off"
                                    href="javascript:void('Insert/Remove Numbered List')"
                                    title="Insert/Remove Numbered List"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_41_label"
                                    aria-describedby="cke_41_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(65,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(66,event);"
                                    onclick="CKEDITOR.tools.callFunction(67,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__numberedlist_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -1632px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_41_label"
                                      className="cke_button_label cke_button__numberedlist_label"
                                      aria-hidden="false"
                                    >
                                      Insert/Remove Numbered List
                                    </span>
                                    <span
                                      id="cke_41_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    />
                                  </a>
                                  <a
                                    id="cke_42"
                                    className="cke_button cke_button__bulletedlist cke_button_off"
                                    href="javascript:void('Insert/Remove Bulleted List')"
                                    title="Insert/Remove Bulleted List"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_42_label"
                                    aria-describedby="cke_42_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(68,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(69,event);"
                                    onclick="CKEDITOR.tools.callFunction(70,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__bulletedlist_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -1584px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_42_label"
                                      className="cke_button_label cke_button__bulletedlist_label"
                                      aria-hidden="false"
                                    >
                                      Insert/Remove Bulleted List
                                    </span>
                                    <span
                                      id="cke_42_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    />
                                  </a>
                                  <span
                                    className="cke_toolbar_separator"
                                    role="separator"
                                  />
                                  <a
                                    id="cke_43"
                                    className="cke_button cke_button__outdent cke_button_disabled "
                                    href="javascript:void('Decrease Indent')"
                                    title="Decrease Indent"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_43_label"
                                    aria-describedby="cke_43_description"
                                    aria-haspopup="false"
                                    aria-disabled="true"
                                    onkeydown="return CKEDITOR.tools.callFunction(71,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(72,event);"
                                    onclick="CKEDITOR.tools.callFunction(73,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__outdent_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -1320px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_43_label"
                                      className="cke_button_label cke_button__outdent_label"
                                      aria-hidden="false"
                                    >
                                      Decrease Indent
                                    </span>
                                    <span
                                      id="cke_43_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    />
                                  </a>
                                  <a
                                    id="cke_44"
                                    className="cke_button cke_button__indent cke_button_off"
                                    href="javascript:void('Increase Indent')"
                                    title="Increase Indent"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_44_label"
                                    aria-describedby="cke_44_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(74,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(75,event);"
                                    onclick="CKEDITOR.tools.callFunction(76,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__indent_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -1272px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_44_label"
                                      className="cke_button_label cke_button__indent_label"
                                      aria-hidden="false"
                                    >
                                      Increase Indent
                                    </span>
                                    <span
                                      id="cke_44_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    />
                                  </a>
                                  <span
                                    className="cke_toolbar_separator"
                                    role="separator"
                                  />
                                  <a
                                    id="cke_45"
                                    className="cke_button cke_button__blockquote cke_button_off"
                                    href="javascript:void('Block Quote')"
                                    title="Block Quote"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_45_label"
                                    aria-describedby="cke_45_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(77,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(78,event);"
                                    onclick="CKEDITOR.tools.callFunction(79,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__blockquote_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 -216px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_45_label"
                                      className="cke_button_label cke_button__blockquote_label"
                                      aria-hidden="false"
                                    >
                                      Block Quote
                                    </span>
                                    <span
                                      id="cke_45_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    />
                                  </a>
                                </span>
                                <span className="cke_toolbar_end" />
                              </span>
                              <span
                                id="cke_46"
                                className="cke_toolbar"
                                aria-labelledby="cke_46_label"
                                role="toolbar"
                              >
                                <span
                                  id="cke_46_label"
                                  className="cke_voice_label"
                                >
                                  Styles
                                </span>
                                <span className="cke_toolbar_start" />
                                <span
                                  id="cke_10"
                                  className="cke_combo cke_combo__styles cke_combo_off"
                                  role="presentation"
                                >
                                  <span
                                    id="cke_10_label"
                                    className="cke_combo_label"
                                  >
                                    Styles
                                  </span>
                                  <a
                                    className="cke_combo_button"
                                    title="Formatting Styles"
                                    tabIndex={-1}
                                    href="javascript:void('Formatting Styles')"
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_10_label"
                                    aria-haspopup="listbox"
                                    onkeydown="return CKEDITOR.tools.callFunction(81,event,this);"
                                    onfocus="return CKEDITOR.tools.callFunction(82,event);"
                                    onclick="CKEDITOR.tools.callFunction(80,this);return false;"
                                    aria-expanded="false"
                                  >
                                    <span
                                      id="cke_10_text"
                                      className="cke_combo_text cke_combo_inlinelabel"
                                    >
                                      Styles
                                    </span>
                                    <span className="cke_combo_open">
                                      <span className="cke_combo_arrow" />
                                    </span>
                                  </a>
                                </span>
                                <span
                                  id="cke_11"
                                  className="cke_combo cke_combo__format cke_combo_off"
                                  role="presentation"
                                >
                                  <span
                                    id="cke_11_label"
                                    className="cke_combo_label"
                                  >
                                    Format
                                  </span>
                                  <a
                                    className="cke_combo_button"
                                    title="Paragraph Format"
                                    tabIndex={-1}
                                    href="javascript:void('Paragraph Format')"
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_11_label"
                                    aria-haspopup="listbox"
                                    onkeydown="return CKEDITOR.tools.callFunction(84,event,this);"
                                    onfocus="return CKEDITOR.tools.callFunction(85,event);"
                                    onclick="CKEDITOR.tools.callFunction(83,this);return false;"
                                    aria-expanded="false"
                                  >
                                    <span
                                      id="cke_11_text"
                                      className="cke_combo_text cke_combo_inlinelabel"
                                    >
                                      Format
                                    </span>
                                    <span className="cke_combo_open">
                                      <span className="cke_combo_arrow" />
                                    </span>
                                  </a>
                                </span>
                                <span className="cke_toolbar_end" />
                              </span>
                              <span
                                id="cke_47"
                                className="cke_toolbar cke_toolbar_last"
                                aria-labelledby="cke_47_label"
                                role="toolbar"
                              >
                                <span
                                  id="cke_47_label"
                                  className="cke_voice_label"
                                >
                                  about
                                </span>
                                <span className="cke_toolbar_start" />
                                <span
                                  className="cke_toolgroup"
                                  role="presentation"
                                >
                                  <a
                                    id="cke_48"
                                    className="cke_button cke_button__about cke_button_off"
                                    href="javascript:void('About CKEditor 4')"
                                    title="About CKEditor 4"
                                    tabIndex={-1}
                                    hidefocus="true"
                                    role="button"
                                    aria-labelledby="cke_48_label"
                                    aria-describedby="cke_48_description"
                                    aria-haspopup="false"
                                    aria-disabled="false"
                                    onkeydown="return CKEDITOR.tools.callFunction(86,event);"
                                    onfocus="return CKEDITOR.tools.callFunction(87,event);"
                                    onclick="CKEDITOR.tools.callFunction(88,this);return false;"
                                  >
                                    <span
                                      className="cke_button_icon cke_button__about_icon"
                                      style={{
                                        backgroundImage:
                                          'url("https://6valley.6amtech.com/vendor/ckeditor/ckeditor/plugins/icons.png?t=M2GA")',
                                        backgroundPosition: "0 0px",
                                        backgroundSize: "auto",
                                      }}
                                    >
                                      &nbsp;
                                    </span>
                                    <span
                                      id="cke_48_label"
                                      className="cke_button_label cke_button__about_label"
                                      aria-hidden="false"
                                    >
                                      About CKEditor 4
                                    </span>
                                    <span
                                      id="cke_48_description"
                                      className="cke_button_label"
                                      aria-hidden="false"
                                    />
                                  </a>
                                </span>
                                <span className="cke_toolbar_end" />
                              </span>
                            </span>
                          </span>
                          <div
                            id="cke_1_contents"
                            className="cke_contents cke_reset"
                            role="presentation"
                            style={{ height: "200px" }}
                          >
                            <span id="cke_52" className="cke_voice_label">
                              Press ALT 0 for help
                            </span>
                            <iframe
                              src
                              frameBorder={0}
                              className="cke_wysiwyg_frame cke_reset"
                              style={{ width: "100%", height: "100%" }}
                              title="Rich Text Editor, editor"
                              aria-describedby="cke_52"
                              tabIndex={0}
                              allowTransparency="true"
                            />
                          </div>
                          <span
                            id="cke_1_bottom"
                            className="cke_bottom cke_reset_all"
                            role="presentation"
                            style={{ userSelect: "none" }}
                          >
                            <span
                              id="cke_1_resizer"
                              className="cke_resizer cke_resizer_vertical cke_resizer_ltr"
                              title="Resize"
                              onmousedown="CKEDITOR.tools.callFunction(1, event)"
                            >
                              ◢
                            </span>
                            <span
                              id="cke_1_path_label"
                              className="cke_voice_label"
                            >
                              Elements path
                            </span>
                            <span
                              id="cke_1_path"
                              className="cke_path"
                              role="group"
                              aria-labelledby="cke_1_path_label"
                            >
                              <span className="cke_path_empty">&nbsp;</span>
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-md-12">
                      <input
                        className="form-control btn-primary"
                        type="submit"
                        name="btn"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default AdminBusinessSettingsTermsCondition;
